import * as React from 'react';
import styled from 'styled-components';
import { Card } from '../../designSystem/Card';
import { logout } from '../../api/adminClientApi';
import { AmorgAdminPageProvider } from '../_contexts/AmorgAdminPageContext';

export function AmorgAdminLogout():JSX.Element
{
    React.useEffect(() => {
        const doLogout = async () => {
            await logout();
        };
        doLogout();
    }, []);

    return (
        <AmorgAdminPageProvider>
            <Wrapper>
                <Card variant="outlined">
                    Du er logget ud....<br />
                    Log ind igen <a href="/amorgy/login">her...</a>
                </Card>
            </Wrapper>
        </AmorgAdminPageProvider>
    );
}

const Wrapper = styled.div`
    width:400px;
    height: 600px;
    margin: auto;
    padding-top:100px;
`;